import { V2WellBeing } from "src/pages/reports/fsci/v2/types";

export const meta: Record<V2WellBeing, Opportunity> = {
    healthyLiving: {
        title: "Healthy Living",
        prologue: "Students are happy with their physical health, including sufficient exercise and a healthy diet.",
    },
    resilience: {
        title: "Resilience",
        prologue: "Students handle stress effectively and respond well to/bounce back from difficult situations.",
    },
    stress: {
        title: "Stress",
        prologue:
            "Constant feelings of stress and being overwhelmed accompany a lack of time to prepare for instruction (Teachers) or to focus on physical health (Leaders).",
        extra: "* The higher the score on this construct, the more respondents disagreed with the construct’s items. Thus, in general, a higher score would mean that fewer respondents felt constantly stressed and overwhelmed.",
    },
};
